// extracted by mini-css-extract-plugin
module.exports = {"heading":"add-order-dialog_heading__GSmxb","button":"add-order-dialog_button__qgIK4","tooltipBox":"add-order-dialog_tooltipBox__5_vgN"};